<template>
  <v-container fluid>
    <!-- <v-slide-y-transition mode="out-in"> -->
    <!-- <v-layout column align-center> -->
    <!-- <img src="@/assets/logo.png" alt="Vuetify.js" class="mb-5"> -->
    version 1234
    <a href="tel:022577153" target="_blank">โทร 022577153</a>
    <br />

    <v-btn @click="openlink_newtab('https://oneplatformapp.page.link/h69Bh9uf1NHSiakm6')">
      oneplatformapp_newtab
    </v-btn>
    <a href="https://oneplatformapp.page.link/h69Bh9uf1NHSiakm6">oneplatformapp_href</a>
    <v-btn @click="openlink('https://oneplatformapp.page.link/h69Bh9uf1NHSiakm6')">oneplatformapp_openlink</v-btn>
    <v-btn @click="openlink_newtab2('https://oneplatformapp.page.link/h69Bh9uf1NHSiakm6','https://platform.one.th/manage/download')">
      oneplatformapp_newtab2
    </v-btn>
    <v-btn @click="openlink2('https://oneplatformapp.page.link/h69Bh9uf1NHSiakm6','https://platform.one.th/manage/download')">oneplatformapp_openlink2</v-btn>


<br />
_______________________________________________________
<br />
    <v-btn @click="openlink_newtab('https://uat-teleconsulting.one.th/management/api/v1/sign/viewpdf?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiJleUpoYkdjaU9pSlNVekkxTmlJc0ltcDBhU0k2SW1FNE4yWm1NRFk0TldJMk5tSXdZbUUwTnpNMVl6bG1ZemszTjJObFpEZ3lPVFZrTTJFME5EaGhNVEJqT0dZelpEQTBNMlE1TXpFd09USXlObUk0WWpNd01EazRaVGRrTmpkaE9ETTNPR1JoSWl3aWEybGtJam9pSWl3aWRIbHdJam9pU2xkVUluMC5leUpoZFdRaU9pSTFOemNpTENKbGVIQWlPakUyT1RJNU5UQXlPVFVzSW1wMGFTSTZJbUU0TjJabU1EWTROV0kyTm1Jd1ltRTBOek0xWXpsbVl6azNOMk5sWkRneU9UVmtNMkUwTkRoaE1UQmpPR1l6WkRBME0yUTVNekV3T1RJeU5tSTRZak13TURrNFpUZGtOamRoT0RNM09HUmhJaXdpYVdGMElqb3hOamt5T1RRNU56ZzNMQ0p1WW1ZaU9qRTJPVEk1TkRrM09EY3NJbk4xWWlJNklqTXhORE01TnpjM01qSWlMQ0p6WTI5d1pYTWlPbHRkTENKMWMyVnlibUZ0WlNJNkltMXBiblJ3WVhKd1lYTnBjbWtpZlEuT0FVMzVIT3NtYnhkSXBlRmFPVmE0QTY0U01rMzFQcklua29rM1BHc3FHSWVOUlZVRVR5Q2pxN0o1U3ZYUGJjaHM3MXA2Q1RZQU4teTZ2UkxJOFMydW1WMWhjSWluamVITGFTMUdjM01DUjZjNzM0M3ZyeUVCVXNrM3BGOTBiWkpudVJSdVdKXzEycG55YkFwbjlTUzhSU3lENjZXRFhfZ0pkWm5UcHhLQVZjQW5VVE16YTBpOEV0MEpDUEpVRTR2WFNVMGJYdTVlMXl5Y2VkdUEtY0E0WjNLQi1Sc1JtSEVXNjQybC1aV1NqR3dOUVFETVlBeVVyblBITXQtLUZZVlNwY2V4TktydnVhdWN0cmFnSDJXTElfY0VFS21GTHVLdEdsNTd4REpKdjFwQ1lyUmIwbXBOTkUxcXNMYUxrd24wWXNYYmoweWg2N1pRSGNCNlZ3VzVRIn0.AHz0oI_AGJPX4JTfRltwmgpbYo8YbdcTHj8RQNOpP04&biz_id=324265892276395&year=&platform=web&doc_code=MEDICAL_CERTIFICATE')">DHI Newtab</v-btn>
    <v-btn @click="openlink_newtab('https://google.co.th')">love google</v-btn>
    <v-btn @click="openlink_newtab('https://chat.one.th')">love</v-btn>
    <v-btn @click="openlink_newtab('https://chat.one.th/qrcode/friend?id=VTUyZDhiYmZkMDBhMjU5MzZhMGMyZjZkNjY5Y2IxZjJh')">Bot 77</v-btn>
    <v-btn @click="openlink_newtab('https://chat.one.th/service/link-to-bot-room?bot_token=B90193abe4a725c0b87a634cad6d74421')">Bot JAMTEST2(น่าจะไม่มีคนแอด)</v-btn>
    <v-btn @click="openlink_newtab('https://chat.one.th/service/link-to-bot-room?bot_token=B2e44b62af2985c548ccca79d0bce8e71')">Bot OneChat</v-btn>
    <v-btn @click="openlink_newtab('https://chat-api.one.th/go_api/api/v1/openUploadProfilePicture')">openUploadProfilePicture</v-btn>
    <v-btn @click="openlink_newtab('https://chat-api.one.th/go_api/api/v1/openScanQRcode')">openScanQRcode</v-btn>
    <a href="https://chat-develop.one.th">onechatself</a>
    <a href="https://chat.one.th" target="_blank">onechat</a>
    <a href="https://chat.one.th/qrcode/friend?id=QmRkMjMyYTkxOTVhYzVmMTFhODYyZDU4MTVmYTJjYjJk" target="_blank">addfriend</a>
    <v-btn @click="openlink('https://chat-develop.one.th')">onechat-develop</v-btn>
    <v-btn @click="openlink('https://chat.one.th/qrcode/friend?id=QmRkMjMyYTkxOTVhYzVmMTFhODYyZDU4MTVmYTJjYjJk')">addfriend</v-btn>
    <br />
    <br />
    <a href="mailto:onechat@one.th" class="">onechat@one.th</a>
    <a href="tel:+66866655885" class="">0866655885</a>
    <br />
    <a href="mailto:onechat@one.th" target="_blank">onechat@one.th_blank</a>
    <a href="tel:+66866655885" target="_blank">0866655885_blank</a>
    <br />
    <a href="fb-messenger://share/?link=http%3A%2F%2F203.151.152.129%3A9091%2Ftracking%2F" target="_blank">fb</a>
    <a href="intent://msg/text/One%20Express%0D%0Ahttp%3A%2F%2F203.151.152.129%3A9091%2Ftracking%2F%0D%0A%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B2%E0%B8%A1%E0%B8%AA%E0%B8%96%E0%B8%B2%E0%B8%99%E0%B8%B0%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%82%E0%B8%99%E0%B8%AA%E0%B9%88%E0%B8%87#Intent;scheme=line;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=jp.naver.line.android;end" target="_blank">intent</a>
    <v-btn @click="alerthello()">Alert</v-btn>
    <v-btn @click="payment()">thaidotcompayment</v-btn>
    <form id="__PostForm" name="__PostForm" action="https://test.thaidotcompayment.co.th/INETServiceWeb/api/v1/card_payment/ktc" method="POST">
      <input type="hidden" name="access_token" value='UliTsN4yfrsg7ISVSHlrVuWP3Sway3yolXApU2xktegtSMkagJ0tGLCexge2kQWBae9rMSxvVNm2u8MieZFnkOgrEr+Yso8MJyiyMsINW5gqQl37bzcqNN0hSITpF2X03xPSk+rRV7J4/NEOKUz95diFtNLmW+Nk9awPo68Ldug='>
    </form>
    <v-btn color="primary" @click="scanqrcode()">
      alert qrcode
    </v-btn>
    <v-btn @click="openlink('https://deeponespace.mylivingplatform.com/')">mylivingplatform</v-btn>
    <v-btn @click="openlink('http://chat-develop.one.th/deeplink-redirect/?url=http://google.co.th')">onechat_deeplink</v-btn>
    <v-btn @click="openlink('http://chat-develop.one.th/deeplink-redirect/toMarket/?url=https://nooim.one.th?access_token={auth_token}')">deeplink_nooim</v-btn>
    <hr>
    ดาวน์โหลดไฟล์
    <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic('pdfTest.pdf','https://chat-public.one.th:8000/getmessage_image_v2/5f22799fa7fbd700365ce881/A92pZSYpNGU60af97ed5e255a979e5ec83eac46f446_2020-07-30_07:41:18:754176.pdf')">
      <v-icon>file_download</v-icon> pdf
    </v-btn>
    <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic('pngTest.png','https://chat-public.one.th:8000/getmessage_image_v2/5f3f3a881d7a480035bf7426/JGYiYgHJu9U60af97ed5e255a979e5ec83eac46f446_2020-08-21_03:07:52:274891.png')">
      <v-icon>file_download</v-icon> png
    </v-btn>
    <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic('jpgTest.jpg','https://chat-public.one.th:8000/getmessage_image_v2/5f20df84a7fbd700365cb6cc/yvq5tUvxwiU60af97ed5e255a979e5ec83eac46f446_2020-07-29_02:31:32:536292.jpg')">
      <v-icon>file_download</v-icon> jpg
    </v-btn>
    <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic('mp4Test.mp4','https://chat-public.one.th:8000/getmessage_image_v2/5f3f3acf54dca200351f2af8/ilDmPUOcrYU60af97ed5e255a979e5ec83eac46f446_2020-08-21_03:09:03:227381.mp4')">
      <v-icon>file_download</v-icon> mp4
    </v-btn>
    <v-btn depressed small class="btnallow CSChatThai" id="btn-download" @click="loadpic('docxTest.docx','https://chat-public.one.th:8000/getmessage_image_v2/5f3f3b041d7a480035bf7431/MNuhdZKpu7U60af97ed5e255a979e5ec83eac46f446_2020-08-21_03:09:56:495253.docx')">
      <v-icon>file_download</v-icon> docx
    </v-btn>

    <!-- <button onclick="askForLocation()">Get Location</button> -->
    <!-- </v-layout> -->
    <!-- </v-slide-y-transition> -->
    <!--  <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera">
    <v-btn @click="switchCamera" outlined fab small style="float: right; margin-top: 40px;">
      <v-icon style="color: #2562af; font-size: 24px;">switch_camera</v-icon>
    </v-btn>
  </qrcode-stream> -->
    <!-- <v-btn color="primary" @click="opencamra"></v-btn>
<video id="video" width="640" height="480" autoplay></video> -->
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Privacy Policy
        </v-card-title>
        <v-card-text>
          <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera">
            <v-btn @click="switchCamera" outlined fab small style="float: right; margin-top: 40px;">
              <v-icon style="color: #2562af; font-size: 24px;">switch_camera</v-icon>
            </v-btn>
          </qrcode-stream>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closedialog()">
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script type="text/javascript">
import Vue from 'vue'
// import VueQrcodeReader from 'vue-qrcode-reader'
import {
  QrcodeStream
} from 'vue-qrcode-reader'
import VueQrcode from '@xkeshi/vue-qrcode'

Vue.component(VueQrcode.name, VueQrcode)

export default {
  data: function() {
    return {
      res: {},
      user: '',
      expire: '',
      data: {},
      dialog: false,
      camera: 'auto',
      noStreamApiSupport: false,
      noRearCamera: false,
      noFrontCamera: false,
      result: '',
      weburl2: '',
      share_token_test: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiJleUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUpTVXpJMU5pSXNJbXAwYVNJNklqZGxNVGxrWTJNeE9UYzRPRGt6TkRZNE9HVmxNV05rTm1ZMFkyRmxORE5qT0RGalltRXhNVFl6TXpnek9XWTRaVFl4T0RReVpUVXdPR05tT0RBell6QmpOVGd6TW1SaE5HSmxORE15WmpObElpd2lhMmxrSWpvaUluMC5leUpoZFdRaU9pSXlJaXdpYW5ScElqb2lOMlV4T1dSall6RTVOemc0T1RNME5qZzRaV1V4WTJRMlpqUmpZV1UwTTJNNE1XTmlZVEV4TmpNek9ETTVaamhsTmpFNE5ESmxOVEE0WTJZNE1ETmpNR00xT0RNeVpHRTBZbVUwTXpKbU0yVWlMQ0pwWVhRaU9qRTJNVFF3TnpnNE1UZ3NJbTVpWmlJNk1UWXhOREEzT0RneE9Dd2laWGh3SWpveE5qRTBNRGM1TVRFNExDSnpkV0lpT2lJMU1ETTRNVE0xTXpFeU1DSXNJblZ6WlhKdVlXMWxJam9pZEdoaGJtRjBhR2x3SW4wLm1OdlBVd19YUW84bHdRWEx0SUtBYXRGUDFLTm01YUw2LVl6b0ZhdmgyMHNiVjRWLW5sazktc1BnWWdaT1dyRVd5VVF6djRab3FNcVRLVzZ0WktmRFllQm9jRlpwZEQwbTNRcVVFRDlDWWFhcGZFV3dncDJ0Z3d6OHMtMlQ3aGNyanNQbWVMTjZ1dUVvZ3lpZmloVi1zaG1DRUlBc3NOMk5PVVBIeDdORTQxd2JKaV9KMnVLLWRhUWVxLTZHaWZsaDRTRGQySlR0Sk5PZ2dCenJGYkxCQkhBN1M0YTc0SUhBMXBIbFB1ajV1OUtFc3d1TG5QcG43Rk5SNDZtNUdYckJLZ1dVbEdETmxoN0M5Zll3dnZKM1NUUDRQRi1SUGxHcEZoTTl0cF9sdVZRR1NLZlU3TThITkZFend3WU5hZ3pxZXVwN2pod3l0YlYtbnV6aS1UVGIyUSJ9.Ir1gMamJQPlgvxgQoyyXvLmx-hxhi2T9_3A9mbVN-pQ'
    }
  },
  created() {
    alert('jam ')
  },
  components: {
    QrcodeStream
  },
  watch: {
    weburl2() {
      // alert(this.weburl2)
      // console.log(this.weburl2)
      // this.openlink_newtab(this.weburl2)
    }
  },
  mounted() {
    // var postform = document.__PostForm
    // postform.submit()
  },
  methods: {
    loadpic(filenameSend, linkfile) {
      // console.log(this.DetailFile)
      this.$http.get(linkfile, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filenameSend)
        document.body.appendChild(link)
        link.click()
      })
    },
    logErrors(promise) {
      promise.catch(console.error)
    },
    closedialog() {
      this.dialog = false
      // this.camera = 'off'
    },
    onDecode(result) {
      console.log(result)
      // this.result = result
      // if (this.result !== '') {
      //   this.checkonechat(result)
      // } else {
      //   alert(result)
      // }
    },
    switchCamera() {
      // console.log(this.camera)
      switch (this.camera) {
        case 'front':
          this.camera = 'auto'
          // console.log(this.camera)
          // alert(this.camera)
          break
        case 'rear':
          this.camera = 'auto'
          // console.log(this.camera)
          // alert(this.camera)
          break
        case 'auto':
          this.camera = 'front'
          // console.log(this.camera)
          // alert(this.camera)
          break
      }
    },
    async onInit(promise) {
      // console.log(promise)
      // alert(promise)
      try {
        // console.log(promise)
        // alert(promise)
        await promise
      } catch (error) {
        // console.log(error)
        // console.log(error.name)
        // alert(error)
        const triedFrontCamera = this.camera === 'front'
        const triedRearCamera = this.camera === 'rear'

        const cameraMissingError = error.name === 'OverconstrainedError'

        if (triedRearCamera && cameraMissingError) {
          this.noRearCamera = true
        }

        if (triedFrontCamera && cameraMissingError) {
          this.noFrontCamera = true
        }
        if (error.name === 'StreamApiNotSupportedError') {
          this.noStreamApiSupport = true
        } else if (error.name === 'NotAllowedError') {
          // console.log('กรุณาอนุญาตการใช้งานกล้อง')
          this.alert_message = 'NotAllowedError'
          // if('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices){
          //   navigator.permissions.query({name: 'camera'})
          //    .then((permissionObj) => {
          //     console.log(permissionObj)
          //     console.log(permissionObj.state)
          //    })
          //    .catch((error) => {
          //     console.log('Got error :', error)
          //    })
          // }
        }
      }
    },
    scanqrcode() {
      this.dialog = true
    },
    alerthello() {
      alert('hello')
    },
    payment() {
      var postform = document.__PostForm
      postform.submit()
    },
    openlink(link) {
      window.open(link)
    },
    openlink_newtab(link) {
      // alert('openlink_newtab')
      window.open(link, '_blank')
    },
    openlink2(link,link2) {
      window.open(link)
      window.open(link2)
    },
    openlink_newtab2(link,link2) {
      // alert('openlink_newtab')
      window.open(link, '_blank')
       window.open(link2, '_blank')
    },
    openlink_newtab_testmiew(link) {
      this.$http.post('https://chat-api.one.th/message/api/v1/get_encode_shared_token', { user_id: '50381353120' }).then((response) => {
        if (response.data.status === 'success') {
          // var url = ''
          // if (_.includes(link, ['?'])) {
          //   // url = '&share_token='

          //   // http://chat-develop.one.th/deeplink-redirect/?url=https://onebinar.one.th/event/CFBOXB?share_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiJleUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUpTVXpJMU5pSXNJbXAwYVNJNklqZGxNVGxrWTJNeE9UYzRPRGt6TkRZNE9HVmxNV05rTm1ZMFkyRmxORE5qT0RGalltRXhNVFl6TXpnek9XWTRaVFl4T0RReVpUVXdPR05tT0RBell6QmpOVGd6TW1SaE5HSmxORE15WmpObElpd2lhMmxrSWpvaUluMC5leUpoZFdRaU9pSXlJaXdpYW5ScElqb2lOMlV4T1dSall6RTVOemc0T1RNME5qZzRaV1V4WTJRMlpqUmpZV1UwTTJNNE1XTmlZVEV4TmpNek9ETTVaamhsTmpFNE5ESmxOVEE0WTJZNE1ETmpNR00xT0RNeVpHRTBZbVUwTXpKbU0yVWlMQ0pwWVhRaU9qRTJNVFF3TnpnNE1UZ3NJbTVpWmlJNk1UWXhOREEzT0RneE9Dd2laWGh3SWpveE5qRTBNRGM1TVRFNExDSnpkV0lpT2lJMU1ETTRNVE0xTXpFeU1DSXNJblZ6WlhKdVlXMWxJam9pZEdoaGJtRjBhR2x3SW4wLm1OdlBVd19YUW84bHdRWEx0SUtBYXRGUDFLTm01YUw2LVl6b0ZhdmgyMHNiVjRWLW5sazktc1BnWWdaT1dyRVd5VVF6djRab3FNcVRLVzZ0WktmRFllQm9jRlpwZEQwbTNRcVVFRDlDWWFhcGZFV3dncDJ0Z3d6OHMtMlQ3aGNyanNQbWVMTjZ1dUVvZ3lpZmloVi1zaG1DRUlBc3NOMk5PVVBIeDdORTQxd2JKaV9KMnVLLWRhUWVxLTZHaWZsaDRTRGQySlR0Sk5PZ2dCenJGYkxCQkhBN1M0YTc0SUhBMXBIbFB1ajV1OUtFc3d1TG5QcG43Rk5SNDZtNUdYckJLZ1dVbEdETmxoN0M5Zll3dnZKM1NUUDRQRi1SUGxHcEZoTTl0cF9sdVZRR1NLZlU3TThITkZFend3WU5hZ3pxZXVwN2pod3l0YlYtbnV6aS1UVGIyUSJ9.Ir1gMamJQPlgvxgQoyyXvLmx-hxhi2T9_3A9mbVN-pQ

          //   this.weburl2 = 'http://chat-develop.one.th/deeplink-redirect/?url=' + link + '&share_token=' + this.share_token_test
          // } else {
          //   // url = '?share_token='
          //   this.weburl2 = 'http://chat-develop.one.th/deeplink-redirect/?url=' + link + '?share_token=' + this.share_token_test
          // }
          this.weburl2 = 'http://chat-develop.one.th/deeplink-redirect/?url=https://onebinar.one.th/event/CFBOXB?share_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiJleUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUpTVXpJMU5pSXNJbXAwYVNJNklqZGxNVGxrWTJNeE9UYzRPRGt6TkRZNE9HVmxNV05rTm1ZMFkyRmxORE5qT0RGalltRXhNVFl6TXpnek9XWTRaVFl4T0RReVpUVXdPR05tT0RBell6QmpOVGd6TW1SaE5HSmxORE15WmpObElpd2lhMmxrSWpvaUluMC5leUpoZFdRaU9pSXlJaXdpYW5ScElqb2lOMlV4T1dSall6RTVOemc0T1RNME5qZzRaV1V4WTJRMlpqUmpZV1UwTTJNNE1XTmlZVEV4TmpNek9ETTVaamhsTmpFNE5ESmxOVEE0WTJZNE1ETmpNR00xT0RNeVpHRTBZbVUwTXpKbU0yVWlMQ0pwWVhRaU9qRTJNVFF3TnpnNE1UZ3NJbTVpWmlJNk1UWXhOREEzT0RneE9Dd2laWGh3SWpveE5qRTBNRGM1TVRFNExDSnpkV0lpT2lJMU1ETTRNVE0xTXpFeU1DSXNJblZ6WlhKdVlXMWxJam9pZEdoaGJtRjBhR2x3SW4wLm1OdlBVd19YUW84bHdRWEx0SUtBYXRGUDFLTm01YUw2LVl6b0ZhdmgyMHNiVjRWLW5sazktc1BnWWdaT1dyRVd5VVF6djRab3FNcVRLVzZ0WktmRFllQm9jRlpwZEQwbTNRcVVFRDlDWWFhcGZFV3dncDJ0Z3d6OHMtMlQ3aGNyanNQbWVMTjZ1dUVvZ3lpZmloVi1zaG1DRUlBc3NOMk5PVVBIeDdORTQxd2JKaV9KMnVLLWRhUWVxLTZHaWZsaDRTRGQySlR0Sk5PZ2dCenJGYkxCQkhBN1M0YTc0SUhBMXBIbFB1ajV1OUtFc3d1TG5QcG43Rk5SNDZtNUdYckJLZ1dVbEdETmxoN0M5Zll3dnZKM1NUUDRQRi1SUGxHcEZoTTl0cF9sdVZRR1NLZlU3TThITkZFend3WU5hZ3pxZXVwN2pod3l0YlYtbnV6aS1UVGIyUSJ9.Ir1gMamJQPlgvxgQoyyXvLmx-hxhi2T9_3A9mbVN-pQ'
          // var weburl1 = link + url + 'share_token=' + response.data.data.encode_shared_token
          // this.weburl2 = 'http://chat-develop.one.th/deeplink-redirect/?url=' + link + '' + url + '' + this.share_token_test
          // alert(this.weburl2)
          // window.open(weburl2, '_blank')
          // return false;
        }
      }).catch(error => {
        alert(error)
        // this.message_alert = 'ไม่มีข้อมูลผู้ใช้ในระบบ'
        // this.snackbar = true
      })
    },
    openlink_newtab_testmiewV2(link) {
      this.$http.post('https://chat-api.one.th/message/api/v1/get_encode_shared_token', { user_id: '50381353120' }).then((response) => {
        if (response.data.status === 'success') {
          var url = ''
          if (_.includes(link, ['?'])) {
            url = '&share_token='
          } else {
            url = '?share_token='
          }
          // var weburl1 = link + url + '' + response.data.data.encode_shared_token
          // var weburl2 = `https://chat-develop.one.th/deeplink-redirect/?url=${weburl1}`
          this.weburl2 = 'http://chat-develop.one.th/deeplink-redirect/?url=' + link + '' + url + '' + this.share_token_test
          // alert(this.weburl2)
          // window.open(weburl2, '_blank')
          // return false;

          // encode_shared_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiJleUowZVhBaU9pSktWMVFpTENKaGJHY2lPaUpTVXpJMU5pSXNJbXAwYVNJNklqZGxNVGxrWTJNeE9UYzRPRGt6TkRZNE9HVmxNV05rTm1ZMFkyRmxORE5qT0RGalltRXhNVFl6TXpnek9XWTRaVFl4T0RReVpUVXdPR05tT0RBell6QmpOVGd6TW1SaE5HSmxORE15WmpObElpd2lhMmxrSWpvaUluMC5leUpoZFdRaU9pSXlJaXdpYW5ScElqb2lOMlV4T1dSall6RTVOemc0T1RNME5qZzRaV1V4WTJRMlpqUmpZV1UwTTJNNE1XTmlZVEV4TmpNek9ETTVaamhsTmpFNE5ESmxOVEE0WTJZNE1ETmpNR00xT0RNeVpHRTBZbVUwTXpKbU0yVWlMQ0pwWVhRaU9qRTJNVFF3TnpnNE1UZ3NJbTVpWmlJNk1UWXhOREEzT0RneE9Dd2laWGh3SWpveE5qRTBNRGM1TVRFNExDSnpkV0lpT2lJMU1ETTRNVE0xTXpFeU1DSXNJblZ6WlhKdVlXMWxJam9pZEdoaGJtRjBhR2x3SW4wLm1OdlBVd19YUW84bHdRWEx0SUtBYXRGUDFLTm01YUw2LVl6b0ZhdmgyMHNiVjRWLW5sazktc1BnWWdaT1dyRVd5VVF6djRab3FNcVRLVzZ0WktmRFllQm9jRlpwZEQwbTNRcVVFRDlDWWFhcGZFV3dncDJ0Z3d6OHMtMlQ3aGNyanNQbWVMTjZ1dUVvZ3lpZmloVi1zaG1DRUlBc3NOMk5PVVBIeDdORTQxd2JKaV9KMnVLLWRhUWVxLTZHaWZsaDRTRGQySlR0Sk5PZ2dCenJGYkxCQkhBN1M0YTc0SUhBMXBIbFB1ajV1OUtFc3d1TG5QcG43Rk5SNDZtNUdYckJLZ1dVbEdETmxoN0M5Zll3dnZKM1NUUDRQRi1SUGxHcEZoTTl0cF9sdVZRR1NLZlU3TThITkZFend3WU5hZ3pxZXVwN2pod3l0YlYtbnV6aS1UVGIyUSJ9.Ir1gMamJQPlgvxgQoyyXvLmx-hxhi2T9_3A9mbVN-pQ"

        }
      }).catch(error => {
        alert(error)
      })
    },
    openlink_newtab_testmiewV3(link) {
      this.weburl2 = link
    },
    logout() {
      // this.$Onechat.getAPI('m1', 'm2').then((res) => {
      //   console.log(res)
      //   this.res = res
      // })
      // this.res = await this.$Onechat.getAPI('m1', 'm2')
      // localStorage.clear()
      // this.$router.push('/login')
      // this.$socket.emit('leave', {room: this.token})
      // this.$socket.emit('disconnect')

      var headers = {
        'Authorization': 'Bearer Aafb3999ded975541ad59d798392beae94d02ee0a68fb4108a9a9db4ef9213cd4306b174554db4db6ba89e269a7686b45'
      }
      this.$http.post(process.env.APImanage + '/api/v1/getprofile', {
        bot_id: 'Bdd232a9195ac5f11a862d5815fa2cb2d',
        source: this.$route.query.onechat_token
      }, {
        headers: headers
      }).then((response) => {
        this.res = response.body
      }, (response) => {})
    }
  }
}

</script>
<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
>>>.wrapper[data-v-e0ba7c1e] {
  position: relative !important;
  z-index: 0 !important;
  width: 70% !important;
  height: 30% !important;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/test4.vue